export const SERVICE_TYPE_FILTER_FA = {
    name: 'Financial advice',
    type: 1,
};
export const SERVICE_TYPE_FILTER_MA = {
    name: 'Mortgage advice',
    type: 2,
};
export const SERVICE_TYPE_FILTER_LEGAL = {
    name: 'Legal advice',
    type: 4,
};
export const SERVICE_TYPE_FILTER_PROTECTION = {
    name: 'Protection advice',
    type: 3,
};

export const SERVICE_TYPE_FILTER_TRANSFERRED_CLIENTS = {
    name: 'Transferred clients',
    type: 5,
};
export const SERVICE_TYPE_FILTER_EQUITY_RELEASE = {
    name: 'Equity release',
    type: 6,
};

export const SERVICE_TYPE_FILTERS = [
    SERVICE_TYPE_FILTER_FA,
    SERVICE_TYPE_FILTER_MA,
    SERVICE_TYPE_FILTER_LEGAL,
    SERVICE_TYPE_FILTER_PROTECTION,
    SERVICE_TYPE_FILTER_EQUITY_RELEASE
];
export const SERVICE_TYPE_FILTERS_EXCLUDING_LEGAL = [
    SERVICE_TYPE_FILTER_FA,
    SERVICE_TYPE_FILTER_MA,
    SERVICE_TYPE_FILTER_PROTECTION,
    SERVICE_TYPE_FILTER_EQUITY_RELEASE
];

export const GOALS = {
    1: "Prospect Conversion",
    2: "Client Advocacy",
    3: "Risk Mitigation"
}

export const LOCKED_RANKING_TOOLTIP_TITLE = "You need more than 30 responses for each question to unlock your industry ranking. This is a percentile ranking against advisers in the industry"
export const LOCKED_RANKING_TOOLTIP_DESCRIPTION = "Cannot be ranked"

export const METRICS = [
    {
        id: 1,
        name: "Prospect conversion"
    },
    {
        id: 2,
        name: "Recommendations per client"
    },
    {
        id: 3,
        name: "Potential risk"
    },
]

export const API_ELEVATION_V2_ENDPOINTS = [
    'questions/breakdown',
    'scores',
    'primary-service-type',
    'questions/answers-to-qualifying-questions',
    'metric-qualifying-questions'
];